const state = {
  our_service: [],
  our_service_id: [],
};

export default state;
